import {IParams as IEllipsisDropdownParams} from "../button/ellipsis-dropdown";
import th_checkboxHtml from './th-checkbox.html?raw';

export const template = th_checkboxHtml;

export interface IAllCheckbox<T> {
    key?: keyof T | undefined,
    toggle: () => void // toggles all items in current page
    isChecked: () => boolean // are all items on current page checked?
    isIndeterminate: () => boolean // are some items on current page checked?
    isEnabled: () => boolean
    selected: KnockoutObservableArray<T>
    show?: () => boolean

    // dropdownParams
    dropdownParams?: IDropdownParams | undefined
}

export interface IDropdownParams {
    numPageItems: () => number
    toggle_all: () => void // toggles all items in current search
    isChecked_all: () => boolean
    total: () => number
}

export class viewModel {
    private ellipsisDropdownParams: IEllipsisDropdownParams | null = null

    constructor(private obj: IAllCheckbox<any>) {
        const dropdownParams = obj.dropdownParams;
        if (dropdownParams) {
            this.ellipsisDropdownParams = {
                buttons: [
                    {
                        label: () => `Velg alle på siden (${dropdownParams.numPageItems()})`,
                        onClick: () => this.obj.toggle(),
                        enabled: () => this.obj.isEnabled() && !this.obj.isChecked(),
                    },
                    {
                        label: () => `Velg alle i søkeresultatet (${dropdownParams.total()})`,
                        onClick: () => dropdownParams.toggle_all(),
                        enabled: () => dropdownParams.total() > 0 && !dropdownParams.isChecked_all(),
                    },
                    {
                        label: () => `Fjern alle valgte (${this.obj.selected()?.length})`,
                        onClick: () => this.obj.selected([]),
                        enabled: () => !!this.obj.selected()?.length,
                    },
                ],
                icon: 'fal fa-angle-down',
            }
        }
    }
}